import { usePageTitle } from "./hooks/usePageTitle";

function Links() {
  usePageTitle('Useful Links')
  return (
    <div
      id="ts-links-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-links-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Links to External Websites
        </div>
        <div className="text-normal mt-4">
          <span>
            TERRASCIENCES is not responsible for the contents of any such web
            pages or any link(s) contained on those web pages, or any changes or
            updates to those web pages. TERRASCIENCES provides such links solely
            as a convenience, and the inclusion of any link does not imply
            endorsement by TERRASCIENCES.
          </span>
        </div>
        <div className="w-full flex flex-col text-light-text mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Interesting Websites
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.cgmlarson.com/"
              >
                Larson CGM
              </a>{" "}
              - A supplier of CGM plotting and viewing software. Includes a free
              CGM viewer for Windows.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.sdicgm.com/"
              >
                SDI - System Development, Inc.
              </a>{" "}
              - Another supplier of CGM plotting and viewing software.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.webgis.com/index.html"
              >
                WebGIS
              </a>{" "}
              - Resource page providing DLG, DEM and Land use digital data - for
              free download.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://pubs.usgs.gov/of/2003/ofr-03-420/ofr-03-420.html"
              >
                A Catalog of Porosity and Permeability from Core Plugs in
                Siliciclastic Rocks
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://visibleearth.nasa.gov/"
              >
                Visible Earth (NASA)
              </a>{" "}
              - A searchable directory of satellite imagery, visualizations, and
              animations of Earth.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://geodesy.noaa.gov/"
              >
                Links to Coordinates, Datums, and Transformation Information
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.ngdc.noaa.gov/geomag-web/#declination"
              >
                Magnetic Declination calculation site
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://wwwbrr.cr.usgs.gov/projects/GW_borehole/bibliography/"
              >
                Bibliography of Borehole Geophysics as Applied to Ground Water
                Hydrology
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.ngdc.noaa.gov/mgg/shorelines/shorelines.html"
              >
                Coastline Data for Geopolitical Maps
              </a>{" "}
              - Provides coastlines as lat/long coordinates (MapGen format) —
              courtesy of NOAA.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.geology.wisc.edu/~wang/petroleum.html"
              >
                Internet Petroleum Resources
              </a>{" "}
              - A large list of industry-related web sites (colleges, societies,
              surveys, companies, etc.).
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="https://www.fcc.gov/media/radio/dms-decimal"
              >
                Convert Degrees Minutes Seconds to Decimal Degrees
              </a>{" "}
              - A useful online utility.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="https://www.nga.mil/resources/1595966558609_Resources.html"
              >
                National Geospatial Intelligence Agency
              </a>{" "}
              - Source of spheroid and projection information.
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.fault-analysis-group.ucd.ie/papermodels/papermodels.htm"
              >
                Fault Analysis Group, University College Dublin
              </a>{" "}
              - Folding paper models to explain faults; downloadable models.
            </li>
          </ul>
        </div>

        <div className="w-full flex flex-col text-light-text mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Industrial Societies and Organisations
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.spwla.org/"
              >
                SPWLA - Society of Petroleum Well Log Analysts
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.aapg.org/"
              >
                AAPG - American Association of Petroleum Geologists
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.cwls.org/"
              >
                CWLS - Canadian Well Log Society
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.pesgb.org.uk/"
              >
                PESGB - The Petroleum Exploration Society of Great Britain
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.pttc.org/"
              >
                PTTC - Petroleum Technology Transfer Council
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.petroleum.co.uk/"
              >
                The Institute of Petroleum
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.seg.org/"
              >
                SEG - Society of Exploration Geophysicists
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://dwls.spwla.org/"
              >
                DWLS - Denver Well Log Society
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.lps.org.uk/"
              >
                LPS - London Petrophysical Society
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.hgs.org/"
              >
                HGS - Houston Geological Society
              </a>
            </li>
          </ul>
        </div>

        <div className="w-full flex flex-col text-light-text mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Geologic Surveys
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <a
                className="font-bold text-light-text-link"
                href="https://www.dur.ac.uk/"
              >
                University of Durham
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="https://www.ncl.ac.uk/"
              >
                University of Newcastle
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://pangea.stanford.edu/"
              >
                Stanford University School of Earth Sciences
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="https://www.hw.ac.uk/"
              >
                Heriot Watt University
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.gfz-potsdam.de/"
              >
                GeoForschungsZentrum
              </a>{" "}
              - German Geoscientific Research Institute
            </li>
          </ul>
        </div>

        <div className="w-full flex flex-col text-light-text mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Miscellaneous
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <a
                className="font-bold text-light-text-link"
                href="https://travel.state.gov/content/travel/en/traveladvisories/traveladvisories.html/"
              >
                US State Department Travel Advisories
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.fco.gov.uk/travel"
              >
                UK Foreign &amp; Commonwealth Office Travel Advice
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.timeanddate.com/worldclock"
              >
                Current Time In Various Cities around the world
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.xe.com/ucc"
              >
                Currency Conversion Site
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.softtrades.com/"
              >
                International Direct Dial (IDD) Codes
              </a>
            </li>
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.flightstats.com/go/Home/home.do"
              >
                Flightstats.com
              </a>{" "}
              - Check the status of flights, and more.
            </li>
          </ul>
        </div>

        <div className="w-full flex flex-col text-light-text mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Just for Fun
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <a
                className="font-bold text-light-text-link"
                href="http://www.esa.int/Our_Activities/Human_Spaceflight/International_Space_Station/Where_is_the_International_Space_Station"
              >
                Track the International Space Station
              </a>{" "}
              - a link courtesy of ESA.
            </li>
            <li>
                <a
                className="font-bold text-light-text-link"
                href="https://xkcd.com/2170/">
                    Coordinate Precision
                </a>{" "}
                - do you really need that many significant figures?
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Links;
